import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../redux/store";
import { selectAuth } from "../redux/auth/auth.selector";
import { Paths } from "../routes/paths";

const GuestGuard = ({ children }: PropsWithChildren) => {
  const { isAuthorized, isInitialized } = useAppSelector(selectAuth);

  if (!isInitialized) return null;

  if (isAuthorized) {
    return <Navigate to={`/${Paths.home}`} />;
  }

  return <>{children}</>;
};

export default GuestGuard;
